import ExcludeIcon from '@/assets/icons/exclude.svg?react';
import { BuildingBlockDetails } from '@/components/elements/building-blocks/details-building-block/details-building-block.component';
import { NoResults } from '@/components/elements/no-results/no-results.component';
import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';
import { Inclusion, ProductBuildingBlock } from '@/gql/graphql';
import { useIntl } from 'react-intl';
import { tailoringMessages } from '../tailoring.messages';

type BBSelectionProps = {
  // product: Product;
  selectedBB: ProductBuildingBlock | undefined;
  handleBBInclusion: (bb: ProductBuildingBlock) => void;
  isProductActive: boolean;
};

const isSelectedBBIncluded = (bb: ProductBuildingBlock) => {
  return bb?.inclusion.actual === Inclusion.Included || bb?.inclusion.actual === Inclusion.Pending;
};

export const BBSelection = ({ isProductActive, selectedBB, handleBBInclusion }: BBSelectionProps) => {
  const t = useIntl();

  return (
    <>
      {!selectedBB && <NoResults message={<T {...tailoringMessages.noBuildingBlockSelected} />} />}
      {selectedBB && (
        <div className="p-4 bg-light-gray col-span-1">
          <div className="flex flex-row justify-between items-center">
            <h2 className="mb-4">
              {t.formatMessage(tailoringMessages.bbSectionTitle, {
                name: selectedBB.name,
              })}
            </h2>
            {isProductActive && (
              <Button
                onClick={() => {
                  handleBBInclusion(selectedBB);
                }}
                variant="secondary"
                className="mb-4"
              >
                {isSelectedBBIncluded(selectedBB) ? (
                  <>
                    <ExcludeIcon className="mr-2" />
                    <T {...tailoringMessages.exclude} />
                  </>
                ) : (
                  <T {...tailoringMessages.include} />
                )}
              </Button>
            )}
          </div>

          <div className="bg-white p-4 rounded flex flex-col gap-4">
            <BuildingBlockDetails buildingBlock={selectedBB} />
          </div>
        </div>
      )}
    </>
  );
};
